/**
 * better-auth client SDK for the AJNT UI.
 *
 * Configured to point at the gateway's /api/auth/** handler.
 * Exports the auth client instance and React hooks.
 */
import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";

const API_BASE = "https://api.ajnt.ai";

export const authClient = createAuthClient({
  baseURL: API_BASE,
  plugins: [organizationClient()],
  fetchOptions: {
    credentials: "include" as RequestCredentials,
  },
});

/* Re-export convenience hooks from better-auth/react */
export const { useSession } = authClient;
